/*const marqueeContainer = document.querySelector('.marquee_banner');

const marquee = document.querySelector('.marquee_banner-inner');

let hovering;

let negativeMargin = null;

marqueeContainer.addEventListener('hover', () => hovering = true);
marqueeContainer.addEventListener('mouseLeave', () => hovering = false);

function marqueeLoop() {
  let items =[...document.querySelectorAll('.scroll_text')];
  if(items[0].getBoundingClientRect().right <= 0){
    //let item = items.shift();
    negativeMargin = -1;
    marquee.appendChild(items.shift());
  }else{
  marquee.style.marginLeft = `${negativeMargin}px`;
  negativeMargin = negativeMargin - 50;
  console.log(negativeMargin);
  }
}

window.setInterval(marqueeLoop, 500);
*/

function initMarqueeBanner() {
  const container = document.querySelector('.marquee_banner-inner');
  if (!container) return;

  const direction = getComputedStyle(container).getPropertyValue('--direction').trim() || 'scroll-left';
  const speed = getComputedStyle(container).getPropertyValue('--marquee-speed').trim() || '20s';

  const existingTrack = container.querySelector('.marquee-track');
  if (existingTrack) existingTrack.remove();

  const originalItems = Array.from(container.querySelectorAll('.scroll_text')).map(item => item.cloneNode(true));
  if (originalItems.length === 0) return;

  container.innerHTML = '';

  const track = document.createElement('div');
  track.classList.add('marquee-track', direction);
  track.style.setProperty('--marquee-speed', speed);

  const innerWrapper = document.createElement('div');
  innerWrapper.classList.add('marquee-inner-wrapper');
  innerWrapper.style.display = 'flex';

  // Clone items 3 times
  for (let i = 0; i < 3; i++) {
    originalItems.forEach(item => innerWrapper.appendChild(item.cloneNode(true)));
  }

  track.appendChild(innerWrapper);
  container.appendChild(track);

  // Temporarily disable animation until layout is stable
  innerWrapper.classList.add('not-ready');

  // Force layout and allow animation after a tick
  requestAnimationFrame(() => {
    // Add marquee-ready class to start animation
    innerWrapper.classList.remove('not-ready');
    innerWrapper.classList.add('marquee-ready');
  });

  // Inject styles
  if (!document.querySelector('#marquee-styles')) {
    const style = document.createElement('style');
    style.id = 'marquee-styles';
    style.textContent = `
      .marquee-track {
        overflow: hidden;
        display: flex;
        width: 100%;
      }

      .marquee-inner-wrapper {
        display: flex;
        will-change: transform;
      }

      /* Animation only runs when marquee-ready is added */
      .marquee-inner-wrapper.marquee-ready {
        animation: marquee-scroll-left var(--marquee-speed) linear infinite;
      }

      .marquee-track.scroll-left .marquee-inner-wrapper.marquee-ready {
        animation-name: marquee-scroll-left;
      }

      .marquee-track.scroll-right .marquee-inner-wrapper.marquee-ready {
        animation-name: marquee-scroll-right;
      }

      .marquee_banner-inner:hover .marquee-inner-wrapper {
        animation-play-state: paused;
      }

      @keyframes marquee-scroll-left {
        0% { transform: translateX(0); }
        100% { transform: translateX(-33.333%); }
      }

      @keyframes marquee-scroll-right {
        0% { transform: translateX(-33.333%); }
        100% { transform: translateX(0); }
      }
    `;
    document.head.appendChild(style);
  }
}

document.addEventListener('DOMContentLoaded', initMarqueeBanner);
